module.exports = __webpack_public_path__ + "static/media/Logo_fitwohnen.f0288c69.png";